import React from 'react'
import './MedicalRecordsUpload.css'
import backIcon from "../../Assets/Images/Expand_left.png";
import folder from "../../Assets/Images/folder.png";
import { useNavigate } from 'react-router-dom';

const MedicalRecordsUpload = () => {
    const navigate = useNavigate();

    const handleBackClick = () => {
        navigate(-1);  // Navigates back to the previous page
    }

    const handleFolderClick = (folderName) => {
        // Navigate to the respective folder page
        navigate(`/${folderName}`);
    }

    return (
        <div className='meicalrecordupload-container'>
            <div className="upload-header">
                <button className="back-button" onClick={handleBackClick}>
                    <img src={backIcon} alt="Back" className="back-icon" />
                </button>
                <h1>Medical Records</h1>
            </div>

            <div className='upload-images'>
                <div className='prescription' onClick={() => handleFolderClick('prescriptions')}>
                    <img src={folder} alt="folder" className="folder-icon" />
                    <h3>Prescriptions</h3>
                </div>

                <div className='prescription' onClick={() => handleFolderClick('medicine-bills')}>
                    <img src={folder} alt="folder" className="folder-icon" />
                    <h3>Medicine Bills</h3>
                </div>

                <div className='prescription' onClick={() => handleFolderClick('medicine-pictures')}>
                    <img src={folder} alt="folder" className="folder-icon" />
                    <h3>Medicine Pictures</h3>
                </div>

                <div className='prescription' onClick={() => handleFolderClick('home-tests')}>
                    <img src={folder} alt="folder" className="folder-icon" />
                    <h3>Home Tests</h3>
                </div>

                <div className='prescription' onClick={() => handleFolderClick('lab-reports')}>
                    <img src={folder} alt="folder" className="folder-icon" />
                    <h3>Lab Reports</h3>
                </div>

            </div>
        </div>
    )
}

export default MedicalRecordsUpload
